import deepmerge from 'deepmerge';
import { AbstractFacade, plainToInstanceWithLVS } from '@goparrot/common';
import { ReadWebStoreDto } from '../generated-dto';
import { WebStoreExposeGroup } from '../interface';
import { WebStoreUrlsDto } from '../dto';
export class WebStoreFacade extends AbstractFacade {
    constructor(config = {}, interceptors = {}) {
        super(deepmerge({
            axiosConfig: {
                baseURL: process.env.GOPARROT_PLATFORM_SERVICE_WEBSTORE,
            },
        }, config), interceptors);
        this.basePrefix = '/api/v2/web-stores';
    }
    async get(storeId, mergedWithWebMerchant = false) {
        return plainToInstanceWithLVS(ReadWebStoreDto, (await this.client.get(`${this.basePrefix}/${storeId}`, { params: { mergedWithWebMerchant } })).data, {
            groups: [WebStoreExposeGroup.READ],
        });
    }
    async urls(storeId, userId) {
        return plainToInstanceWithLVS(WebStoreUrlsDto, (await this.client.get(`${this.basePrefix}/${storeId}/urls`, {
            params: {
                userId,
            },
        })).data);
    }
    async patch(storeId, data) {
        return plainToInstanceWithLVS(ReadWebStoreDto, (await this.client.patch(`${this.basePrefix}/${storeId}`, data)).data, {
            groups: [WebStoreExposeGroup.READ],
        });
    }
    async list(searchFilter) {
        return plainToInstanceWithLVS(ReadWebStoreDto, (await this.client.get(this.basePrefix, { params: searchFilter })).data, {
            groups: [WebStoreExposeGroup.READ],
        });
    }
    async setStyle(data) {
        return this.client.post(`${this.basePrefix}/styles/replace`, data);
    }
}
//# sourceMappingURL=WebStoreFacade.js.map